// extracted by mini-css-extract-plugin
module.exports = {"main":"SchoolBadge_main__v5iU7","label":"SchoolBadge_label__wg2oB","logo":"SchoolBadge_logo__j6kwN"};